import { Checkbox } from '../../ui/checkbox';
import { Pencil, Trash2, TriangleAlert } from 'lucide-react';
import { Spinner } from '../../ui/spinner';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '../../ui/tooltip';
import _, { isArray } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'src/components/ui/BrandSelect';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import { Button } from '../../ui/button';
import { adminPortalSelect } from '../../utils/ReactSelectStyles';

const ConversionFactorsTable = ({
  branding,
  page,
  filterSize,
  tableSize,
  setTotalItems,
  setShowHide,
  setFilter,
  filter,
  totalItems,
  options,
  setShowPagination,
  canEditAdminPortal,
  toggleModal,
  profiles,
  getAllItemsFromDB,
  showLoader,
  conversionFactors,
  updateCheckedItems,
  handleTableSizeChange,
  toggleSelectAllChecked,
  setOpenSearchTerms,
}) => {
  const get_OS_terms = () => ({ filters: filter, page, tableSize: tableSize.value });

  const tableFontFamily =
    branding?.fonts?.[0]?.font?.body || "ui-sans-serif, system-ui, sans-serif, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const checkedList = conversionFactors?.filter((item) => item.checked);

  const selectAll = () => {
    toggleSelectAllChecked(!selectAllChecked);
    setSelectAllChecked(!selectAllChecked);
  };

  useEffect(() => {
    if (checkedList.length === 0) {
      setSelectAllChecked(false);
    }
  }, [checkedList.length]);

  useEffect(() => {
    getAllItemsFromDB('profile');
    window.scrollTo({ top: 1, behavior: 'smooth' });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTotalItems(totalItems);
  }, [totalItems, setTotalItems]);

  if (showLoader) return <Spinner />;

  if (conversionFactors && !isArray(conversionFactors)) {
    //Error Message
    return <div>{conversionFactors}</div>;
  }

  const _headerRenderer = () => {
    return <div>{conversionFactors.length > 1 && <Checkbox checked={selectAllChecked} onCheckedChange={selectAll} />}</div>;
  };

  const bulkRenderer = ({ cellData, rowData }) => {
    return (
      <Checkbox
        checked={rowData?.checked}
        //cellData here is cellID
        onCheckedChange={() => updateCheckedItems(cellData)}
        aria-label='controlled'
      />
    );
  };

  const formatUsageTypesValues = ({ cellData, rowData, dataKey }) => {
    if (
      [
        'subentity',
        'vehicle',
        'production',
        'metric',
        'waste',
        'seat',
        'load',
        'fuel',
        'price',
        'finallocation',
        'originlocation',
        'factorprovider',
      ].includes(dataKey) &&
      cellData !== null &&
      cellData !== undefined &&
      cellData !== 'null'
    ) {
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className='cursor-pointer admin_portal_cellData_description'
                style={{ whiteSpace: 'pre-wrap', overflow: 'hidden', height: 'inherit' }}>
                {cellData && _.find(options?.[dataKey], { value: cellData })?.label}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData && _.find(options?.[dataKey], { value: cellData })?.label}</TooltipContent>
          </Tooltip>
        </div>
      );
    } else {
      if (cellData === null || cellData === 'null' || cellData === undefined) {
        return (
          <div>
            <Tooltip>
              <TooltipTrigger asChild>
                <div style={{ textAlign: 'center', overflowX: 'auto', maxHeight: '100px', opacity: '40%' }}>{'<null>'}</div>
              </TooltipTrigger>
              <TooltipContent>{'<null>'}</TooltipContent>
            </Tooltip>
          </div>
        );
      }
    }

    if (dataKey === 'addOns') {
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className='cursor-pointer admin_portal_cellData_description'>
                {cellData && cellData?.map((item) => _.find(options?.[dataKey], { value: item })?.label + ' ')}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData?.map((item) => _.find(options?.[dataKey], { value: item })?.label + ' ')}</TooltipContent>
          </Tooltip>
        </div>
      );
    }

    if (dataKey === 'creationDate' || dataKey === 'modificationDate' || dataKey === 'discontinuedDate')
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className='cursor-pointer admin_portal_cellData_description'
                style={{ whiteSpace: 'pre-wrap', overflow: 'hidden', height: 'inherit' }}>
                {cellData && moment(cellData).format('DD/MM/YYYY')}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData && moment(cellData).format('DD/MM/YYYY')}</TooltipContent>
          </Tooltip>
        </div>
      );

    if (dataKey === 'userId') {
      const user = profiles?.find((user) => user.id === rowData.userId);
      const userName = user ? user?.firstName + ' ' + user?.lastName : '';
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className='cursor-pointer admin_portal_cellData_description'>
                {userName}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData}</TooltipContent>
          </Tooltip>
        </div>
      );
    }

    if (dataKey)
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className='cursor-pointer admin_portal_cellData_description'>
                {cellData}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData}</TooltipContent>
          </Tooltip>
        </div>
      );
  };

  const userActions = ({ rowData }) => {
    return (
      <div className='flex items-center justify-center'>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className='cursor-pointer' onClick={() => toggleModal(true, 'conversionFactors-table-edit', rowData)}><Pencil size={16} strokeWidth={1.5} /></span>
          </TooltipTrigger>
          <TooltipContent>Edit Conversion Factor</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className='ml-1 cursor-pointer' onClick={() => toggleModal(true, 'conversionFactors-delete', rowData)}><Trash2 size={16} strokeWidth={1.5} /></span>
          </TooltipTrigger>
          <TooltipContent>Delete Conversion Factor</TooltipContent>
        </Tooltip>
      </div>
    );
  };

  if (conversionFactors && !conversionFactors.length > 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className='alert-message'>
          <TriangleAlert size={16} strokeWidth={1.5} />
          <span>No Conversion Factor Found</span>
        </div>
        <Button
          id='reset-btn'
          onClick={() => {
            setFilter({});
            setTotalItems(0);
            setShowPagination(false);
            setShowHide(false);
          }}
          style={{ width: '10vh', height: 'fit-content', fontSize: 16, marginLeft: '2vh' }}>
          Reset
        </Button>
      </div>
    );
  }

  return (
    <TooltipProvider>
    <section className='panel font-sans' style={{ fontFamily: tableFontFamily }}>
      <header
        className='panel-heading font-sans'
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', fontFamily: tableFontFamily }}>
        <span>Conversion Factors Results</span>
        <div style={{ marginRight: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Select
            options={filterSize}
            name={'tableSize'}
            defaultValue={filterSize[0]}
            onChange={handleTableSizeChange}
            styles={{
              ...adminPortalSelect,
              control: (x) => ({ ...x, ...adminPortalSelect.control, width: 100 }),
              container: (x) => ({ ...x, paddingBottom: 0 }),
            }}
            placeholder={'Table Size'}
            value={tableSize}
          />
          <Button
            id='reset-btn'
            onClick={() => {
              setOpenSearchTerms({});
              setFilter({});
              setTotalItems(0);
              setShowPagination(false);
              setShowHide(false);
            }}
            style={{ width: '10vh', fontSize: 16, marginLeft: '3vh', textTransform: 'none' }}>
            Reset
          </Button>
          {checkedList?.length > 1 && (
            <>
              <div style={{ marginRight: '1.5vh' }}>
                <Button
                  variant='outline'
                  size='sm'
                  style={{ width: '12vh', fontSize: 16, marginLeft: '3vh', textTransform: 'none' }}
                  onClick={() => {
                    toggleModal(true, 'conversionFactors-bulk_edit', checkedList, null, get_OS_terms());
                  }}>
                  Bulk Edit
                </Button>
              </div>
              <div>
                <Button
                  variant='outline'
                  size='sm'
                  style={{ width: '15vh', fontSize: 16, textTransform: 'none' }}
                  onClick={() => {
                    toggleModal(true, 'conversionFactors-bulk_delete', checkedList, null, get_OS_terms());
                  }}>
                  Bulk Delete
                </Button>
              </div>
            </>
          )}
        </div>
      </header>
      <div className='panel-body' style={{ height: '100vh', overflowX: 'auto' }}>
        <div style={{ width: '100%', height: '100%', display: !conversionFactors?.length > 0 ? 'none' : 'block' }}>
          <AutoSizer>
            {({ width, height }) => (
              <Table
                width={width + 1000}
                height={height}
                rowHeight={100}
                headerHeight={50}
                headerStyle={{ verticalAlign: 'bottom', width: '100%', display: 'flex', justifyContent: 'center' }}
                rowStyle={({ index }) => {
                  const rowData = conversionFactors[index];
                  const shouldHighlight = rowData && rowData.checked;
                  return {
                    backgroundColor: shouldHighlight ? 'lightblue' : 'white',
                    textAlign: 'center',
                    textOverflow: 'auto-flow',
                    fontSize: 13,
                  };
                }}
                headerClassName='admin_portal_column_headers'
                rowCount={conversionFactors.length}
                rowGetter={({ index }) => conversionFactors[index]}>
                {canEditAdminPortal && (
                  <Column dataKey='id' width={60} headerRenderer={_headerRenderer} cellRenderer={bulkRenderer} />
                )}
                {canEditAdminPortal && <Column label='Actions' dataKey='id' width={75} cellRenderer={userActions} />}
                <Column label='Id' dataKey='id' width={75} cellRenderer={formatUsageTypesValues} />
                <Column width={50} id='year-column' label='Year' dataKey='year' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={150}
                  id='subentity-column'
                  label='Subentity'
                  dataKey='subentity'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={85} id='seat-column' label='Seat' dataKey='seat' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={85}
                  id='vehicle-column'
                  label='Vehicle'
                  dataKey='vehicle'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={85} id='fuel-column' label='Fuel' dataKey='fuel' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={90}
                  id='production-column'
                  label='Production'
                  dataKey='production'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={85} id='load-column' label='Load' dataKey='load' cellRenderer={formatUsageTypesValues} />
                <Column width={85} id='waste-column' label='Waste' dataKey='waste' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={85}
                  id='waste-column'
                  label='Price Type'
                  dataKey='price'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column
                  width={100}
                  id='waste-column'
                  label='Origin Location'
                  dataKey='originlocation'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column
                  width={100}
                  id='waste-column'
                  label='Final Location'
                  dataKey='finallocation'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column
                  width={100}
                  id='factorprovider-column'
                  label='Factor Provider'
                  dataKey='factorprovider'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column
                  width={85}
                  id='metric-column'
                  label='Metric'
                  dataKey='metric'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={85} label='CO2e' dataKey='co2e' cellRenderer={formatUsageTypesValues} />
                <Column width={85} label='CO2' dataKey='co2' cellRenderer={formatUsageTypesValues} />
                <Column width={85} label='CH4' dataKey='ch4' cellRenderer={formatUsageTypesValues} />
                <Column width={85} label='WTT' dataKey='wtt' cellRenderer={formatUsageTypesValues} />
                <Column width={85} label='N2O' dataKey='n2o' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={200}
                  label='Outside of Scopes'
                  dataKey='outsideOfScopes'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={100} label='Scope' dataKey='scope' cellRenderer={formatUsageTypesValues} />
                <Column width={200} label='Notes' dataKey='notes' cellRenderer={formatUsageTypesValues} />
                <Column width={300} label='Source' dataKey='source' cellRenderer={formatUsageTypesValues} />
                <Column width={200} label='Add-Ons' dataKey='addOns' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={200}
                  label='Discontinued Date'
                  dataKey='discontinuedDate'
                  cellRenderer={formatUsageTypesValues}
                />
                <Column width={150} label='Creation Date' dataKey='creationDate' cellRenderer={formatUsageTypesValues} />
                <Column
                  width={200}
                  label='Modification Date'
                  dataKey='modificationDate'
                  cellRenderer={formatUsageTypesValues}
                />
              </Table>
            )}
          </AutoSizer>
        </div>
      </div>
    </section>
    </TooltipProvider>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { page, setTableSize, tableSize, handleTableSizeChange } = ownProps;
  const tableName = 'conversionFactors';

  return {
    showLoader: state?.showLoader,
    branding: state.branding,
    totalItems: state?.admin?.termsItems?.totalCount,
    profiles: state?.admin?.adminPortal?.profile,
    tableName,
    filterSize: state.admin?.filterSize,
    conversionFactors: state?.admin?.termsItems?.items || [],
    page,
    tableSize,
    setTableSize,
    handleTableSizeChange,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, action, item, notAutoClose, openSearchTerms) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose, openSearchTerms)),
  filterFromOpeanSearch: (index, query) => dispatch(ADMINACTIONS.filterFromOpeanSearch(index, query)),
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
  updateCheckedItems: (itemId) => dispatch(ADMINACTIONS.updateCheckedItems(itemId)),
  toggleSelectAllChecked: (checked) => dispatch(ADMINACTIONS.toggleSelectAllChecked(checked)),
  setOpenSearchTerms: (terms) => dispatch(ADMINACTIONS.setOpenSearchTerms(terms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConversionFactorsTable);
